(() => {
  if (window.Shopify?.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const sections = document.querySelectorAll('#MainContent > .shopify-section');
  const fold = window.innerHeight;

  const cleanup = (event) => {
    if (event.target !== event.currentTarget || event.propertyName !== 'opacity') return;
    event.currentTarget.classList.remove('almam-reveal', 'is-revealed');
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.addEventListener('transitionend', cleanup);
        entry.target.classList.add('is-revealed');
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  sections.forEach((section) => {
    const rect = section.getBoundingClientRect();
    if (rect.height === 0 || rect.top < fold) return;
    section.classList.add('almam-reveal');
    observer.observe(section);
  });

  window.addEventListener('pagehide', () => {
    observer.disconnect();
    document.querySelectorAll('.almam-reveal').forEach((section) => {
      section.classList.remove('almam-reveal', 'is-revealed');
    });
  });
})();
